import type { RouteRecordRaw } from 'vue-router'
import { $t } from '@/locales'

function Layout() {
  return import('@/layouts/index.vue')
}
// 用户数据管理
const userData: RouteRecordRaw = {
  path: '/sys/userData',
  name: 'userData',
  meta: {
    title: $t('route.userData.title'),
    icon: 'icon-park-outline:data-user',
  },
  component: () => import('@/views/sys/user_data/userDataIndex.vue'),
}
// 预约管理
const reservation: RouteRecordRaw = {
  path: '/customer/reservation',
  name: 'customerReservation',
  meta: {
    title: $t('route.customer.reservation'),
    icon: 'mdi:calendar-clock',
  },
  component: () => import('@/views/customer/reservation/reservationIndex.vue'),
}

// 合作管理
const cooperate: RouteRecordRaw = {
  path: '/customer/cooperate',
  name: 'customerCooperate',
  meta: {
    title: $t('route.customer.cooperate'),
    icon: 'mdi:handshake',
  },
  component: () => import('@/views/customer/cooperate/cooperateIndex.vue'),
}

// 方案管理
const scheme: RouteRecordRaw = {
  path: '/customer/scheme',
  name: 'customerScheme',
  meta: {
    title: $t('route.customer.scheme'),
    icon: 'mdi:file-document-edit',
  },
  component: () => import('@/views/customer/scheme/schemeIndex.vue'),
}

/**
 * 客户管理模块
 */
const routes: RouteRecordRaw = {
  path: '/customer',
  component: Layout,
  name: 'customerRoot',
  meta: {
    title: $t('route.customer.title'),
    icon: 'mdi:account-group',
    alwaysOpened: false,
  },
  children: [
    userData,
    reservation,
    cooperate,
    scheme,

  ],
}
export default routes
